import styled from "styled-components";

export const LightCheckBox = styled.i`
  background-color: #FFFFFF;
`

export const DarkCheckBox = styled.i`
  background-color: #192039;
`